import React, { useEffect, useState } from 'react';

type Props = {
    ShowHidePopup: Function;
    ClosePopup?: Function;
    OnApprove?: Function;
    approveBtnTitle?: string;
    messageTitle?: string;
    messageContent: string;
    onPrevious?: Function;
    actionBtns?:boolean;
};

const SignMessagePopUp = (props: Props) => {

    useEffect(() => {
        if(props.messageTitle === 'העדכון בוצע בהצלחה'){
            let time = 1000;
            setTimeout(() => {
                closePopup();
            }, time);
        }
    
        }, [props.messageTitle])
   

    const closePopup = (status?: string)=>{
        if (props.ClosePopup) {
            props.ClosePopup(status);  
         }
    }

    const approve = () => {
        if (props.OnApprove) {
            props.OnApprove();
        }
    }
    
      return ( <>
        <div className="popup-wrapper small-warning">
            <section className="popup-window rtl">
                <div className="close-icon pointer" onClick={(e:any)=>props.ShowHidePopup()}></div>
                <div className="popup-content">
                    <div className="popup-header">
                        <div className="popup-title">
                            {props.messageTitle}
                        </div>
                    </div>
                    <div className="popup-body">
                        {props.messageContent}
                    </div>
                    <div className="popup-footer">
                        { props.onPrevious ? 
                            (<>
                            
                            <button className="button blue blue-border" onClick={(e: any) => props.onPrevious && props.onPrevious()}>
                                סגור
                            </button>
                            </>) 
                            :
                            (<></>)
                        }
                        {
                            props.OnApprove && (props.actionBtns) ? 
                            (<>
                            
                            <button className="button blue blue-border" onClick={(e: any) => approve()}>
                                {props.approveBtnTitle ? props.approveBtnTitle : 'שמור'}
                            </button>
                            </>) 
                            : (!props.actionBtns?"":(<button className="button white blue-border"  onClick={(e:any)=>closePopup()}>
                            סגור
                        </button>))
                            
                        }
                        
                    </div>
                </div>
            </section>
        </div>
      </>  
        
      );
    }

    export default SignMessagePopUp;
  